import styled from "styled-components"

export const TourOrderWrapper = styled.div`
    .list_status{
        list-style: none;
        justify-content: space-between;
        .list_status_item{
            width: 100%;
            height: 45px;
            &-active{
                background-color: #f2474e ;
                span{
                    color: #f0f0f0 ;
                }
            }
        }
    }
    .filter{
        display: flex;
        align-items: center;
        width: 100%;
        button{
            width: 120px;
            height: 40px;
        }
    }
    .tour_list{
        list-style: none;
    }
    .tour_item{
        display: flex;
        justify-content: space-between;

        .tour_item_main{
            display: flex;
        }
        .tour_image{
            width: 120px;
            height: 120px;
            img{
                width: 100%;
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
        }
    }
    .control{
        .btn_update,.label{
            border-radius: 12px;
            padding: 2px 12px;
            color: #f0f0f0;
            background-color: #3194ff;
            display: block;
            text-align: center;
        }
        .btn_cancel{
            border-radius: 12px;
            padding: 2px 12px;
            color: #f0f0f0;
            display: block;
            text-align: center;
        }
        .label{
            background-color: #f2474e;
        }
    }
    
    .empty_data{
        min-height: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .sale{
        background-color: red;
        width: fit-content;
    }
   
`
